import React from 'react';

import { IconProps } from 'icons/Icon.types';

export function ShieldOff({ size, color }: IconProps) {
  return (
    <svg
      width={size ?? 24}
      height={size ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>ShieldOff</title>
      <path
        d="M3 2L19.5 18.5"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.51282 4.0735C4.76501 4.29022 4.25 4.97521 4.25 5.75432V10.8538C4.25 14.3256 5.92663 17.5836 8.75169 19.6015L10.9828 21.1952C11.5913 21.6298 12.4087 21.6298 13.0172 21.1952L15.2483 19.6015C16.3857 18.7891 17.3369 17.7757 18.0675 16.6282L16.9767 15.5374C16.328 16.6422 15.4483 17.6153 14.3765 18.3809L12.1453 19.9746C12.0584 20.0366 11.9416 20.0366 11.8547 19.9746L9.62355 18.3809C7.19268 16.6445 5.75 13.8411 5.75 10.8538V5.75432C5.75 5.6427 5.82399 5.54461 5.93132 5.51394L6.72616 5.28685L5.51282 4.0735ZM17.6614 14.1008C18.0457 13.0759 18.25 11.9779 18.25 10.8538V5.75432C18.25 5.64271 18.176 5.54461 18.0687 5.51394L12.0687 3.79966C12.0238 3.78683 11.9762 3.78683 11.9313 3.79966L8.37608 4.81544L7.16273 3.60209L11.5192 2.35737C11.8335 2.26759 12.1665 2.26759 12.4808 2.35737L18.4808 4.07166C19.232 4.28631 19.75 4.97298 19.75 5.75432V10.8538C19.75 12.3906 19.4215 13.8856 18.8102 15.2496L17.6614 14.1008Z"
        fill={color ?? 'currentColor'}
      />
    </svg>
  );
}
